// extracted by mini-css-extract-plugin
export default {"page":"C1-z","cartModal":"D1-z","checkout":"E1-z","placeholder":"F1-z","account":"G1-z"};